const H = (props) => {
  return (
    <h1 className="text-beausite font-medium md:text-5xl text-4xl md:leading-tight">
      {props.children}
    </h1>
  )
}

export default H
